import MercureService from "@/services/mercure/MercureService"
import MercureMessageType from "@/model/enum/mercureMessageType"
import CanModule from "@/store/modules/submission/CanModule"
import { CanContent } from "@/model/interfaces/submission/templateSubmission/CanContent"

export default class CanContentMercureService extends MercureService {
  static URI = "can_contents/"

  static createEventSource(canContent: CanContent): EventSource {
    const topic = process.env.VUE_APP_API_URL + this.URI + canContent.id
    return this.newEventSource(topic)
  }

  static onMessage(eventSource: EventSource, type?: MercureMessageType): EventSource {
    eventSource.onmessage = async ev => {
      const canContent = JSON.parse(ev.data)

      type = await this.getTypeFromMessageData(canContent, type)
      switch (type) {
        case MercureMessageType.Update:
          CanModule.updateLocked(canContent)
          break
      }
    }

    return eventSource
  }

  static subscription(canContent: CanContent): EventSource {
    return this.onMessage(this.createEventSource(canContent))
  }
}
